import { Autocomplete, Button, Input, InputWrapperProps, Textarea, TextareaProps } from "@mantine/core";
import { useFormHelperContext } from "../form";
import { useController, useFieldArray } from "react-hook-form";
import { InputWrapper } from "../inputWrapper";
import { useTranslation } from "react-i18next";
import { IconTrash } from "@tabler/icons-react";

export interface FieldInputTextareaProps extends TextareaProps {
    label: string;
    name: string;
    readOnly?: boolean;
    inputWrapper?: InputWrapperProps;
}


export const FieldInputTextarea: React.FC<FieldInputTextareaProps> = ({ label, name, readOnly, placeholder, inputWrapper, ...rest }) => {
    const { register, control } = useFormHelperContext();
    const { field, fieldState: { error }, } = useController({ name, control });

    if (!register) {
        throw new Error("Field.Textarea must be used within a FormHelper component");
    }

    return (
        <InputWrapper label={label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
            <div className="flex flex-col w-full">
                <Textarea
                    {...field}
                    {...rest}
                    placeholder={placeholder}
                    disabled={readOnly || false}
                    data-testid={'field-textarea-' + name}
                />

                {error && (
                    <Input.Error>{error.message}</Input.Error>
                )}
            </div>
        </InputWrapper>

    );
};

export const MultiFieldInputTextarea: React.FC<FieldInputTextareaProps> = ({ label, name, placeholder, inputWrapper, ...rest }) => {
    const { register, control, formState } = useFormHelperContext();

    const {t} = useTranslation('generalMessage')

    const errors = formState.errors
    const { fields, append, remove } = useFieldArray({ control, name });

    if (!register) {
        throw new Error("Field.MultiTextarea must be used within a FormHelper component");
    }

    return (
        <InputWrapper label={label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
            <div className="flex flex-col w-full" key={'multi-' + name}>
                {fields.map((field, index) => {
                    const errIndex = (errors[`${name}[${index}]`] as any)
                    return (
                        <div key={field.id}>
                            <div className="flex flex-grow w-full">
                                <Textarea
                                    key={field.id}
                                    className="flex-grow my-2"
                                    error={
                                        errIndex ? " " : undefined
                                    }
                                    {...rest}
                                    {...register(`${name}.${index}`, { required: "Name is required" })}
                                />
                                <Button  variant="outline" onClick={() => remove(index)} color="red" className="m-auto ml-2"> <IconTrash size={12} /></Button>
                            </div>

                            {errIndex && (
                                <Input.Error>{errIndex.message}</Input.Error>
                            )}

                        </div>

                    )
                })}
                <Button variant="light" className="mt-2" onClick={() => append("")}>{t('addMore')}</Button>
            </div>
        </InputWrapper>

    );
};